import { render } from "./PopUpHandler.vue?vue&type=template&id=6d6f7f16&scoped=true&ts=true"
import script from "./PopUpHandler.vue?vue&type=script&lang=ts"
export * from "./PopUpHandler.vue?vue&type=script&lang=ts"

import "./PopUpHandler.vue?vue&type=style&index=0&id=6d6f7f16&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d6f7f16"]])

export default __exports__